import { Contract } from '@/types/payment';
import { FileObject } from '@/types/shared/file';

interface DocumentMediaLike {
  id: string;
  originalName?: string;
  mimeType?: string;
  sizeBytes?: number;
}

export interface ContractSourceLike {
  id: string;
  contractNumber?: string;
  contract_number?: string;
  issuedAt?: string;
  created_at?: string;
  vehicleCardId?: string;
  listingId?: string;
  listing_id?: string;
  buyerSignatureStatus?: string;
  buyer_signature_status?: Contract['buyer_signature_status'];
  buyerSignatureMethod?: string;
  buyer_signature_method?: Contract['buyer_signature_method'];
  buyerSignatureRequestedAt?: string | null;
  buyer_signature_requested_at?: string | null;
  buyerSignedAt?: string | null;
  buyer_signed_at?: string | null;
  buyerSignedByActorId?: string | null;
  buyer_signed_by_actor_id?: string | null;
  buyerSignedByName?: string | null;
  buyer_signed_by_name?: string | null;
  buyerSignatureNote?: string | null;
  buyer_signature_note?: string | null;
  documentMedia?: DocumentMediaLike | null;
  contract_file?: FileObject;
  contract?: ContractSourceLike;
}

export const normalizeContractFile = (
  documentMedia?: DocumentMediaLike | null,
  fallbackFile?: FileObject,
): FileObject => {
  if (!documentMedia) {
    return fallbackFile as FileObject;
  }

  return {
    id: documentMedia.id,
    url: '',
    name: documentMedia.originalName,
    type: documentMedia.mimeType,
    size: documentMedia.sizeBytes,
    mediaId: documentMedia.id,
  };
};

export const normalizeContract = (contract: ContractSourceLike): Contract => {
  const source = contract?.contract ?? contract;

  return {
    id: source.id,
    contract_number: source.contractNumber || source.contract_number || '',
    created_at: source.issuedAt || source.created_at || '',
    listingId: source.vehicleCardId || source.listingId || source.listing_id || '',
    paymentId: '',
    buyer_signature_status:
      (source.buyerSignatureStatus?.toLowerCase?.() ??
      source.buyer_signature_status ??
      'not_requested') as Contract['buyer_signature_status'],
    buyer_signature_method: (source.buyerSignatureMethod?.toLowerCase?.() ??
      source.buyer_signature_method ??
      null) as Contract['buyer_signature_method'],
    buyer_signature_requested_at:
      source.buyerSignatureRequestedAt ?? source.buyer_signature_requested_at ?? null,
    buyer_signed_at: source.buyerSignedAt ?? source.buyer_signed_at ?? null,
    buyer_signed_by_actor_id:
      source.buyerSignedByActorId ?? source.buyer_signed_by_actor_id ?? null,
    buyer_signed_by_name: source.buyerSignedByName ?? source.buyer_signed_by_name ?? null,
    buyer_signature_note:
      source.buyerSignatureNote ?? source.buyer_signature_note ?? null,
    contract_file: normalizeContractFile(source.documentMedia, source.contract_file),
  };
};
